<template>
  <HKLCardBody
    class="tenancy-document__wrapper no-padding no-shadow"
  >
    <Collapse
      class="tenancy-info__collapse title-font14 overflow-hide-content"
      :title="$t('tenancy.documentSubmission')"
      :expand="true"
      :withBorder="false"
    >
      <template slot="content">
        <TenancyDocumentRemarksVue />
        <a-row type="flex">
          <a-col flex="1">
            <label>{{ $t('documents') }}</label>
            <HkldDropzone
              v-if="hasUpdateRemarksAndDocsAccess"
              :metaData="{ uploadOnTop: true }"
              :sourceId="docSourceId"
            />
            <EditAttachments
              :showEditPencil="showEditPencilFunc"
              :canDelete="hasUpdateRemarksAndDocsAccess"
              :showAllDeleteBtn="false"
              :uploadOnTop="true"
              :sortingToggle="true"
              :sourceId="docSourceId"
            />
          </a-col>
        </a-row>
      </template>
    </Collapse>
  </HKLCardBody>
</template>

<script>
import HKLCardBody from '@/controls/Card/HKLCardBody.vue'
import Collapse from '@/controls/Collapse.vue'
import EditAttachments from '@/controls/EditAttachments.vue'
import HkldDropzone from '@/controls/HkldDropzone.vue'
import { useStoreGetters } from '@/store'
import { computed, unref } from 'vue-demi'
import TenancyDocumentRemarksVue from './TenancyDocumentRemarks.vue'
import { useTenancyPermissions } from '../hook'
export default {
  components: {
    TenancyDocumentRemarksVue,
    HKLCardBody,
    HkldDropzone,
    Collapse,
    EditAttachments,
  },
  setup () {
    const { currentTenancy } = useStoreGetters('ccd', ['currentTenancy'])
    const { hasUpdateRemarksAndDocsAccess } = useTenancyPermissions()
    const docSourceId = computed(() => {
      return unref(currentTenancy).docSourceId || ''
    })
    return {
      showEditPencilFunc: (item, currentUser) => {
        return currentUser.id === item.createdBy && unref(hasUpdateRemarksAndDocsAccess)
      },
      hasUpdateRemarksAndDocsAccess,
      docSourceId,
      currentTenancy,
    }
  },
}
</script>

<style lang="scss" scoped>
@import './tenancy-info-collapse';
.tenancy-document__wrapper {
  margin-top: 12px;
  ::v-deep .tenancy-info__collapse .content {
    padding-bottom: 0;
  }
}
</style>
